export * from './audio-recorder.component';
